var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"services"},[_c('div',{staticClass:"title"},[_vm._v("Duckbill Tech")]),_c('div',{staticClass:"title-underline"}),_c('Carousel',{attrs:{"imgs":_vm.serviceData,"service":true},on:{"getIndex":_vm.getIndex}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }